// extracted by mini-css-extract-plugin
export default {"accent":"Service_accent__eEw-2","container":"Service_container__wQhoK"};